import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { STATUS, VIDEOFEED_STATUS, VIDEOFEED_TYPE } from '../../enums/ENUMS';
import { COMMENT, FILE_ACCESS_TYPE, TOPIC, USER, VIDEOFEED, VIDEO_TYPE } from '../../enums';
import { SortOptions, SortType } from '../../enums/SORT';

type TInitialState = {
  status: STATUS;
  refetchFeedList: boolean;
  feedToMove: VIDEOFEED | null;
  feedsToMove: VIDEOFEED[];
  feedToShare: VIDEOFEED | null;
  detailedFeed: VIDEOFEED | null;
  showMoveFeedModal: boolean;
  feedTransferMode: 'move' | 'copy';
  showShareModal: boolean;
  sort: SortType;
  sortOption: SortOptions;
};

export type DETAILED_VIDEOFEED = {
  id: string;
  title: string;
  size?: number;
  type: VIDEOFEED_TYPE;
  videos: VIDEO_TYPE[];
  access: FILE_ACCESS_TYPE[];
  topics: TOPIC[];
  comments: COMMENT[];
  created_by: Omit<USER, 'last_online' | 'isActive' | 'updated_at' | 'created_at' | 'forgot_password_token'>;
  created_at: string;
  folder_id: string;
  status?: VIDEOFEED_STATUS;
  s3_bucket: string;
  s3_filename: string;
  s3_region: string;
  s3_path: string;
};

const initialState: TInitialState = {
  status: STATUS.IDLE,
  refetchFeedList: false,
  feedToMove: null,
  feedsToMove: [],
  feedToShare: null,
  detailedFeed: null,
  showMoveFeedModal: false,
  feedTransferMode: 'move',
  showShareModal: false,
  sort: SortType.ASC,
  sortOption: SortOptions.UPDATED_AT,
};

export const videoFeedsListSlice = createSlice({
  name: 'videoFeedsListSlice',
  initialState,
  reducers: {
    refetchFeeds: (state) => {
      state.refetchFeedList = !state.refetchFeedList;
    },
    updateFeedToMove: (state, action) => {
      state.feedToMove = action.payload;
    },
    updateFeedsToMove: (state, action: PayloadAction<VIDEOFEED[]>) => {
      state.feedsToMove = action.payload;
    },
    updateFeedToShare: (state, action) => {
      state.feedToShare = action.payload;
    },
    updateShowMoveFeedModal: (state, action) => {
      state.showMoveFeedModal = action.payload;
    },
    updateFeedTransferMode: (state, action: PayloadAction<'move' | 'copy'>) => {
      state.feedTransferMode = action.payload;
    },
    updateShowShareModal: (state, action) => {
      state.showShareModal = action.payload;
    },
    updateDetailedFeed: (state, action) => {
      state.detailedFeed = action.payload;
    },
    updateSortOption: (state, action) => {
      state.sortOption = action.payload;
    },
    updateSortType: (state, action) => {
      state.sort = action.payload;
    },
  },
});

export const {
  refetchFeeds,
  updateFeedToMove,
  updateFeedsToMove,
  updateShowMoveFeedModal,
  updateFeedTransferMode,
  updateFeedToShare,
  updateShowShareModal,
  updateDetailedFeed,
  updateSortOption,
  updateSortType,
} = videoFeedsListSlice.actions;

export default videoFeedsListSlice.reducer;
